import { init as initConfig } from '@cian/config/browser';
import { init as initLogger } from '@cian/logger/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';

import { getEventBusIfDefined } from '@cian/event-bus';

import { initGlobalEventsLogs } from '@cian/events-log';

export function initDependencies() {
  const eventBus = getEventBusIfDefined();

  if (eventBus) {
    eventBus.emit('metrics-loader', {
      type: 'lock-initialization',
    });
  }

  initGlobalBehaviors();
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalEventsLogs();
}
